var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{style:({background: _vm.theme.espotoYellow})},[_c('v-container',{staticClass:"containerText"},[_c('v-layout',{attrs:{"text-center":""}},[_c('v-flex',[_c('div',{staticClass:"mt-5 pa-1 text-left"},[_vm._v(" AGBs ")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }